import { Grid } from "@mui/material";
import type { FC } from "react";
import type { ParticipantListResponse } from "./participantListApi";
import ParticipantListStatusView from "./ParticipantListStatusView";
import ParticipantListVersionSelect from "./ParticipantListVersionSelect";

interface Props {
  readonly resolvedVersionIdx: number;
  readonly participantLists: ParticipantListResponse[];
  readonly selectedList: ParticipantListResponse | undefined;
  readonly onVersionChange: (idx: number | undefined) => void;
}

const ParticipantListVersionStatusRow: FC<Props> = ({
  resolvedVersionIdx,
  participantLists,
  selectedList,
  onVersionChange,
}) => (
  <>
    <Grid size={{ xs: 6, lg: 4 }}>
      <ParticipantListVersionSelect
        selectedIdx={resolvedVersionIdx}
        participantLists={participantLists}
        onChange={onVersionChange}
      />
    </Grid>
    <Grid
      size={6}
      sx={{
        alignContent: "center",
      }}
    >
      {selectedList ? <ParticipantListStatusView status={selectedList.status} /> : null}
    </Grid>
  </>
);

export default ParticipantListVersionStatusRow;
